import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class EventTriggerData extends EntityData<EventTriggerData> {
    @identifier id: number;
    @field name: string;
}
